/**
* Created by lobin on 2020/6/17.
*/
<template>
  <i class="iconfont">
    <slot />
  </i>
</template>

<script type="text/babel">
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" rel="stylesheet/less">
@font-face {
  font-family: 'iconfont';  /* project id 1891383 */
  src: url('//at.alicdn.com/t/font_1891383_vwcnjveel99.eot');
  src: url('//at.alicdn.com/t/font_1891383_vwcnjveel99.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_1891383_vwcnjveel99.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_1891383_vwcnjveel99.woff') format('woff'),
  url('//at.alicdn.com/t/font_1891383_vwcnjveel99.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_1891383_vwcnjveel99.svg#iconfont') format('svg');
}
.iconfont {
  width: 1em;
  height: 1em;
  font-family: 'iconfont';
  font-style: normal;
}
</style>
